import { BaseCpFormModel, ControlProps } from '../../../../models/form/base-cp-form.model';
import { DocumentGroupModel } from '../../../../models/document/document-group.model';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { getCurrentDocumentsFromGroup } from '../../../../models/document/shared.document-model.util';

export class JobRoutineFilesFormModel extends BaseCpFormModel<JobRoutineFilesFormModel, DocumentGroupModel[]> {

  //region FIELDS
  static readonly DOCUMENTS = 'documents';

  documentsControl: UntypedFormControl;

  form: UntypedFormGroup;

  asFormGroup(): UntypedFormGroup {
    this.form.addControl(JobRoutineFilesFormModel.DOCUMENTS, this.documentsControl);

    return this.form;
  }

  asModel(formGroup: UntypedFormGroup, model: DocumentGroupModel[]): DocumentGroupModel[] {
    model = formGroup.get(JobRoutineFilesFormModel.DOCUMENTS).value;

    return model;
  }

  createForm(formModel: JobRoutineFilesFormModel, model: DocumentGroupModel[]): JobRoutineFilesFormModel {
    const documentsProps: ControlProps = ControlProps.of(JobRoutineFilesFormModel.DOCUMENTS);
    documentsProps.withDefaultValue([]);
    documentsProps.withValue(model && Array.isArray(model) ? getCurrentDocumentsFromGroup(model) : []);
    this.initControl(formModel, model, documentsProps);

    formModel.form = new UntypedFormGroup({});

    return formModel;
  }

}
